import React from 'react';
import PropTypes from 'prop-types';

// Components
import Badge from "components/Badge";

SelectedShipmentsCount.propTypes = {
    count: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired
};

function SelectedShipmentsCount({count, total}) {
    return (
        <div style={{marginRight: '16px'}}>
            <Badge
                rounded
                isBold={false}
                size={'large'}
                color={'draft'}
            >
                {count}/{total}
            </Badge>
        </div>
    );
}

export default SelectedShipmentsCount;
